import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.number.constructor";
import _objectSpread from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/*eslint-disable*/
import request from '@/utils/request';
import { parseTime } from '@/utils';

/**
 * 获取报表数据
 *
 * @param params {Object<{ companyId, areaId, startTime, endTime }>}
 */
export function loadReportData() {
  return _loadReportData.apply(this, arguments);
}
function _loadReportData() {
  _loadReportData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var params,
      defaultData,
      data,
      projectList,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          defaultData = {
            // 项目总数
            areaCount: 0,
            // 在职人数
            employeesCount: 0,
            // 	当前在岗
            onDutyCount: 0,
            // 巡查点位
            inspectPlanCount: 0,
            // 值守点位
            dutyPlanCount: 0,
            projectList: []
          };
          if (!(!params || !params.companyId)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", defaultData);
        case 4:
          _context.prev = 4;
          _context.next = 7;
          return request({
            url: 'api/statistics/report/project-overview',
            method: 'post',
            data: params
          });
        case 7:
          data = _context.sent;
          projectList = (data.projectList || []).filter(function (project) {
            return !!project.provinceName;
          }).map(function (project) {
            var onDutyList = (project.onDutyList || []).map(function (duty) {
              return _objectSpread(_objectSpread({}, duty), {}, {
                lng: Number(duty.lng) || null,
                lat: Number(duty.lat) || null,
                timeStr: duty.time ? parseTime(new Date(duty.time)) : ''
              });
            });
            return _objectSpread(_objectSpread({}, project), {}, {
              onDutyList: onDutyList,
              lng: Number(project.lng) || null,
              lat: Number(project.lat) || null
            });
          });
          return _context.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, defaultData), data), {}, {
            projectList: projectList
          }));
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](4);
          return _context.abrupt("return", defaultData);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 12]]);
  }));
  return _loadReportData.apply(this, arguments);
}
export function getCommandCentre(params) {
  return request({
    url: 'api/statistics/getCommandCentre',
    method: 'post',
    data: params
  });
}
export function getMapTopBar(params) {
  return request({
    url: 'api/statistics/getMapTopBar',
    method: 'post',
    data: params
  });
}
export function getMapAreaUserList(params) {
  return request({
    url: 'api/statistics/getMapAreaUserList',
    method: 'post',
    data: params
  });
}
export function saveFence(params) {
  return request({
    url: 'api/electronicFence/saveOrUpdate',
    method: 'post',
    data: params
  });
}
export default {
  loadReportData: loadReportData,
  getMapAreaUserList: getMapAreaUserList,
  getCommandCentre: getCommandCentre,
  getMapTopBar: getMapTopBar,
  saveFence: saveFence
};